import type { Patient } from '@store/patientStore';

export const isCustomPageStepComplete = (
  listEnableButton: Array<boolean | undefined>,
) =>
  listEnableButton.every(
    enable => (typeof enable === 'boolean' && enable) || enable === undefined,
  );

export const buildInitialCustomPageEnableList = (
  patients: Array<Patient | undefined>,
): Array<boolean | undefined> =>
  patients.map(patient => (patient ? false : undefined));

export const updateCustomPageEnableList = ({
  currentList,
  index,
  enable,
}: {
  currentList: Array<boolean | undefined>;
  index: number;
  enable: boolean;
}) => {
  if (currentList[index] === undefined || currentList[index] === enable) {
    return currentList;
  }

  const nextList = [...currentList];
  nextList[index] = enable;
  return nextList;
};

export const getCustomPagePatientDisplayName = ({
  fallbackPatientName,
  patient,
}: {
  fallbackPatientName: string;
  patient?: Patient;
}) => {
  const firstName = patient?.patientDetails?.firstName?.trim();
  const lastName = patient?.patientDetails?.lastName?.trim();

  return firstName || lastName
    ? [firstName, lastName].filter(Boolean).join(' ')
    : fallbackPatientName;
};

export const getIncompleteCustomPagePatientNames = ({
  currentPatientIndex,
  fallbackPatientName,
  listEnableButton,
  patients,
}: {
  currentPatientIndex: number;
  fallbackPatientName: string;
  listEnableButton: Array<boolean | undefined>;
  patients: Array<Patient | undefined>;
}) =>
  patients.reduce<string[]>((acc, patient, index) => {
    if (
      patient &&
      index !== currentPatientIndex &&
      listEnableButton[index] === false
    ) {
      acc.push(
        getCustomPagePatientDisplayName({ fallbackPatientName, patient }),
      );
    }

    return acc;
  }, []);
